import { useQuery } from "@tanstack/react-query";
import { getTargetareFirma } from "@/api/endpoints/targetare";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareFirma(cui: string | null) {
  return useQuery({
    queryKey: queryKeys.targetare.firma(cui ?? ""),
    queryFn: () => getTargetareFirma(cui ?? ""),
    select: (response) => response.data,
    enabled: !!cui,
    retry: 1,
  });
}
